import { createSlice } from '@reduxjs/toolkit';

export interface Teacher {
  id: string;
  name: string;
  email: string;
  subject: string;
  department: string;
  employeeId: string;
  qualification: string;
  experience: number;
  contact: string;
  address: string;
  joinDate: string;
  status: 'active' | 'inactive';
}

interface TeacherState {
  teachers: Teacher[];
  loading: boolean;
  error: string | null;
}

const initialState: TeacherState = {
  teachers: [
    {
      id: '1',
      name: 'Dr. Sarah Wilson',
      email: 'sarah.wilson@school.edu',
      subject: 'Mathematics',
      department: 'Science',
      employeeId: 'EMP001',
      qualification: 'Ph.D. in Mathematics',
      experience: 12,
      contact: '+1234567890',
      address: '123 Teacher Lane, City',
      joinDate: '2020-08-15',
      status: 'active',
    },
    {
      id: '2',
      name: 'Prof. John Anderson',
      email: 'john.anderson@school.edu',
      subject: 'Physics',
      department: 'Science',
      employeeId: 'EMP002',
      qualification: 'M.Sc. Physics',
      experience: 8,
      contact: '+1234567891',
      address: '456 Faculty St, City',
      joinDate: '2021-01-10',
      status: 'active',
    },
  ],
  loading: false,
  error: null,
};

const teacherSlice = createSlice({
  name: 'teachers',
  initialState,
  reducers: {
    setTeachers: (state, action) => {
      state.teachers = action.payload;
    },
    addTeacher: (state, action) => {
      state.teachers.push(action.payload);
    },
    updateTeacher: (state, action) => {
      const index = state.teachers.findIndex(t => t.id === action.payload.id);
      if (index !== -1) {
        state.teachers[index] = action.payload;
      }
    },
    deleteTeacher: (state, action) => {
      state.teachers = state.teachers.filter(t => t.id !== action.payload);
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

export const { setTeachers, addTeacher, updateTeacher, deleteTeacher, setLoading, setError } = teacherSlice.actions;
export default teacherSlice.reducer;